import { render } from "./Help.vue?vue&type=template&id=e67c21a8"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"

import exportComponent from "/home/dschranka/actions-runner/_work/DSchranka/DSchranka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__